import { atom } from "jotai"

export const appLoaderAtom = atom(false)
